import { render, staticRenderFns } from "./PopupConfirmDeletion.vue?vue&type=template&id=cf0ece42&scoped=true&"
import script from "./PopupConfirmDeletion.vue?vue&type=script&lang=ts&"
export * from "./PopupConfirmDeletion.vue?vue&type=script&lang=ts&"
import style0 from "./PopupConfirmDeletion.vue?vue&type=style&index=0&id=cf0ece42&lang=scss&scoped=true&"
import style1 from "./PopupConfirmDeletion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0ece42",
  null
  
)

export default component.exports